import React from 'react';
import { Form } from 'react-bootstrap';

function MnR({ onDataChange, data, surface_type, handleBlur, getFieldState, fieldPrefix = "" }) {

    // Check if data.mnr is an array, if not, use an empty array as a fallback
    const mnrData = Array.isArray(data.mnr) ? data.mnr : Array.from(data.mnr);

    return (
        <table>
            <thead>
                <tr>
                    <th colSpan={2} className="pd__label pd__table-head">Timing (years)</th>
                    <th className="pd__label pd__table-head">Treatment Type</th>
                    <th colSpan={2} className="pd__label pd__table-head">Material</th>
                </tr>
                <tr>
                    <th className="pd__label pd__table-head">Min</th>
                    <th className="pd__label pd__table-head">Max</th>
                    <th className="pd__label pd__table-head"></th>
                    <th className="pd__label pd__table-head">Removal</th>
                    <th className="pd__label pd__table-head">Addition</th>
                </tr>
            </thead>
            <tbody>
                {mnrData.map((record, index) => (
                    <tr key={index}>
                        <td>
                            <Form.Control
                                type="number"
                                size="sm"
                                style={{ width: "100%" }}
                                placeholder="0"
                                name={`mnr[${index}].timing_min`}
                                value={record.timing_min || ''}
                                onChange={onDataChange}
                                onBlur={() => handleBlur(`${fieldPrefix}mnr[${index}].timing_min`, record.timing_min, 'number')}
                                isInvalid={getFieldState(`${fieldPrefix}mnr[${index}].timing_min`).isInvalid}
                            />
                        </td>
                        <td>
                            <Form.Control
                                type="number"
                                size="sm"
                                style={{ width: "100%" }}
                                placeholder="0"
                                name={`mnr[${index}].timing_max`}
                                value={record.timing_max || ''}
                                onChange={onDataChange}
                                onBlur={() => handleBlur(`${fieldPrefix}mnr[${index}].timing_max`, record.timing_max, 'number')}
                                isInvalid={getFieldState(`${fieldPrefix}mnr[${index}].timing_max`).isInvalid}
                            />
                        </td>
                        <td>
                            <Form.Select
                                    size="sm"
                                    className="pd-select-xl"
                                    name={`mnr[${index}].treatment_type`}
                                    value={record.treatment_type}
                                    onChange={onDataChange}>
                                {surface_type === "JPCP" && (
                                    <>
                                        <option value="Unspecified">Unspecified</option>
                                        <option value="Bonded Concrete Overlay (in)">Bonded Concrete Overlay (in)</option>
                                        <option value="Unbonded Concrete Overlay (in)">Unbonded Concrete Overlay (in)</option>
                                        <option value="Asphalt Overlay (in)">Asphalt Overlay (in)</option>
                                        <option value="100% Diamond Grinding w/ Full Depth Replacement (%)">100% Diamond Grinding w/ Full Depth Replacement (%)</option>
                                        <option value="Joint / Crack Sealing (% Joints)">Joint / Crack Sealing (% Joints)</option>
                                        <option value="Concrete Patch  (% Area)">Concrete Patch  (% Area)</option>
                                    </>
                                )}
                                {surface_type === "HMA" && (
                                    <>
                                        <option value="Unspecified">Unspecified</option>
                                        <option value="Bonded Concrete Overlay (in)">Bonded Concrete Overlay (in)</option>
                                        <option value="Unbonded Concrete Overlay (in)">Unbonded Concrete Overlay (in)</option>
                                        <option value="Asphalt Overlay (in)">Asphalt Overlay (in)</option>
                                        <option value="AC Mill and Fill (in)">AC Mill and Fill (in)</option>
                                        <option value="Asphalt Patch (% Area)">Asphalt Patch (% Area)</option>
                                        <option value="Seals (chip, fog, slurry, etc) (% Area)">Seals (chip, fog, slurry, etc) (% Area)</option>
                                    </>
                                )}
                            </Form.Select>
                        </td>
                        <td>
                            <Form.Control
                                type="number"
                                size="sm"
                                className="pd-input-sm"
                                placeholder="0"
                                name={`mnr[${index}].material_removal`}
                                value={record.material_removal || ''}
                                onChange={onDataChange}
                                onBlur={() => handleBlur(`${fieldPrefix}mnr[${index}].material_removal`, record.material_removal, 'number')}
                                isInvalid={getFieldState(`${fieldPrefix}mnr[${index}].material_removal`).isInvalid}
                            />
                        </td>
                        <td>
                            <Form.Control
                                type="number"
                                size="sm"
                                className="pd-input-sm"
                                placeholder="0"
                                name={`mnr[${index}].material_addition`}
                                value={record.material_addition || ''}
                                onChange={onDataChange}
                                onBlur={() => handleBlur(`${fieldPrefix}mnr[${index}].material_addition`, record.material_addition, 'number')}
                                isInvalid={getFieldState(`${fieldPrefix}mnr[${index}].material_addition`).isInvalid}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default MnR;
